import emitAsync from '../utils/emitAsync';
import { useDateStore } from '../stores/useDateStore';
import { usePontosItinerarioStore } from '../stores/usePontosItinerarioStore';
import { useLoadingStore } from '../stores/useLoadingStore';
import { useLinesStore } from '../stores/useLinesStore';

const loadingDates = new Set();
const loadingRequests = new Map();
const { 
  setLoadingLines,
  setLoadingFooter,
  setLoadingFooterTxt
} = useLoadingStore.getState();

export function isLinesRequestActive(
  requestId,
  date
) {

  if (!requestId || !date) {
    return false;
  }

  return (
    loadingRequests.get(requestId) === date &&
    loadingDates.has(date)
  );

}

export function finishLinesRequest(requestId, waitDone = false) {

  if (!requestId) {
    return;
  }

  const date = loadingRequests.get(requestId);

  if (!date) {
    return;
  }

  loadingDates.delete(date);
  loadingRequests.delete(requestId);

  if (!loadingRequests.size) {

    if(!waitDone) {
      setLoadingLines(false);
      setLoadingFooter(false);
      setLoadingFooterTxt('Carregando...');
    }
    

  }

}

export function clearLinesRequests() {

  loadingDates.clear();
  loadingRequests.clear();
  setLoadingLines(false);
  setLoadingFooter(false);
  setLoadingFooterTxt('Carregando...');

}

export async function loadLines(socket) {

   const {
      loadingClients,
      loadingVehicles,
      loadingDrivers
  } = useLoadingStore.getState();

  if (loadingClients || loadingVehicles || loadingDrivers
  ) {
    return false;
  }

  const date = useDateStore.getState().today;

  if (!date) {
    return false;
  }

  // Já existe carregamento desta data
  if (loadingDates.has(date)) {
    return true;
  }

  const pontosStore =
    usePontosItinerarioStore.getState();

  const pontosFilter = [
    ...pontosStore.codigosComPontos
  ];

  const requestId = crypto.randomUUID();

  // =========================
  // LIMPA ESTADO ANTERIOR
  // =========================

  useLinesStore
    .getState()
    .resetLines();

  // =========================
  // REGISTRA REQUEST
  // =========================

  loadingDates.add(date);

  loadingRequests.set(
    requestId,
    date
  );

  try {

    setLoadingLines(true);
    setLoadingFooter(true);
    setLoadingFooterTxt('Carregando linhas...');

    const response = await emitAsync(
      socket,
      'linhas:get',
      {
        requestId,
        date,
        pontosFilter
      }
    );

    if (!response?.ok) {

      finishLinesRequest(requestId);

      return false;
    }

    return true;

  } catch (err) {

    finishLinesRequest(requestId, true);

    console.error(
      'Erro ao iniciar carregamento de linhas:',
      err
    );

    return false;

  }

}

export async function loadPontosByCodigo(
  socket,
  codigo
) {

  const key = String(codigo || '').trim();

  if (
    !socket?.connected ||
    !key
  ) {
    return null;
  }

  try {

    const response =
      await emitAsync(
        socket,
        'pontos:get-by-codigo',
        {
          codigo: key
        }
      );

    if (!response?.ok) {
      return null;
    }

    return {
      codigo: String(response.codigo || key).trim(),

      pontos:
        Array.isArray(response.pontos)
        ? response.pontos
        : []
    };

  } catch (err) {

    console.error('Erro ao carregar pontos do código:', err);

    return null;

  }

}